/**
 * "Edit your accounts" on Your Plan: a direct way back to the self-funding accounts step for a
 * consumer whose plan is finished, without walking the flow from the start, and Back returns to Your
 * Plan. Shown only while self-funding access is active (the accounts step is paid; expired access
 * shows the renewal card instead) and always to advisors and wizards, who can open every step.
 */
import { useConsumerFlow } from './use-consumer-flow';
import { useSelfFundAccess } from './use-self-fund-access';

export function useEditAccountsLink(clientId: string) {
  const { goTo } = useConsumerFlow(clientId);
  const { access, isConsumerSession } = useSelfFundAccess();

  return {
    isVisible: !isConsumerSession || access === 'active',
    open: () => goTo('assessment-accounts', { returnTo: 'your-plan' }),
  };
}
